<template lang="pug">

.vc-order-number-and-placed-date
  .order-number
    span.title {{ `${modelNameLocaleText('quotation')}${attributeLocaleText('quotation', 'number')}` }}
    span {{ quotation.number }}
  .completed-at
    b-tooltip(:label="dateTimeLocaleText(quotation.completed_at)"
              position="is-left"
              type="is-dark"
              size="is-small")
      span {{ timeAgoLocaleText(quotation.completed_at) }}

</template>

<script>
export default {
  // components: {},
  // mixins: [],
  props: {
    quotation: {
      type: Object,
      required: true,
    },
  },
  // data() {
  //   return {}
  // },
  // computed: {},
  // created() {},
  // mounted() {},
  // methods: {}
}
</script>
